import React from 'react';

import AvCheck from '@/components/AvCheck';

export interface SiteProps {
  serviceUrl: string,
  shopContext: string,
  selectedPack: string,
  selectedRouter: string,
  hardwareOfferName: string,
}

const Site = ({
  serviceUrl,
  shopContext,
  selectedPack,
  selectedRouter,
  hardwareOfferName,
}: SiteProps) => (
  <div id="content">
    <section className="section">
      <div className="inner">
        <div className="item-collection">
          <div className="items">
            <div>
              <AvCheck
                serviceUrl={serviceUrl}
                shopContext={shopContext}
                selectedPack={selectedPack}
                selectedRouter={selectedRouter}
                hardwareOfferName={hardwareOfferName}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Site;
